var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2561_6279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 18.7497C16.042 18.7497 18.3337 17.4997 18.3337 12.9163M2.83491 14.9093C2.13324 14.7338 1.66699 14.0934 1.66699 13.3705V10.7963C1.66699 10.073 2.13324 9.43218 2.83491 9.25676C3.51241 9.08718 4.40241 8.89676 5.27741 8.8051C5.87658 8.74218 6.40408 9.09343 6.50366 9.68718C6.59116 10.2055 6.66699 10.9751 6.66699 12.083C6.66699 13.1913 6.59074 13.9609 6.50366 14.4788C6.40366 15.0726 5.87658 15.4238 5.27741 15.3613C4.40241 15.2697 3.51241 15.0788 2.83491 14.9093Z",
    stroke: "#A1A1A1",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1661 14.9093C17.8677 14.7338 18.334 14.0934 18.334 13.3705V10.7963C18.334 10.073 17.8677 9.43218 17.1661 9.25676C16.4886 9.08718 15.5986 8.89676 14.7236 8.8051C14.1244 8.74218 13.5969 9.09343 13.4973 9.68718C13.4098 10.2055 13.334 10.9751 13.334 12.083C13.334 13.1913 13.4102 13.9609 13.4973 14.4788C13.5973 15.0726 14.1244 15.4238 14.7236 15.3613C15.5986 15.2697 16.4886 15.0788 17.1661 14.9093Z",
    stroke: "#A1A1A1",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3337 10.7962V9.58333C18.3337 4.98083 14.6028 1.25 10.0003 1.25C5.39783 1.25 1.66699 4.98083 1.66699 9.58333V10.7962M15.8153 8.96375C15.5778 6.04583 13.0653 3.75 10.0003 3.75C6.93533 3.75 4.42283 6.04583 4.18533 8.96375",
    stroke: "#A1A1A1",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2561_6279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrack);
export default __webpack_public_path__ + "static/media/track.cb7943c8f0f9bf1cd637562c374c28a7.svg";
export { ForwardRef as ReactComponent };